module.exports = __webpack_public_path__ + "img/logo-smartpin.81445d16.png";